import React from 'react';
import {Route, Switch} from "react-router-dom";
import Home from "../pages/home";
import Components from "../pages/components";
import Typology from "../pages/typology";
import TypologyDetails from "../pages/typology/single";
import Writings from "../pages/writings";
import WritingsDetails from "../pages/writings/single";
import Speeches from "../pages/speeches";
import SpeechesDetails from "../pages/speeches/single";
import PublicLecture from "../pages/publicLecture";
import PublicLectureDetails from "../pages/publicLecture/single";
import ClassLecture from "../pages/classLecture";
import ClassLectureDetails from "../pages/classLecture/single";
import Conversations from "../pages/conversations";
import ConversationDetails from "../pages/conversations/single";
import Podcasts from "../pages/podcasts";
import PodcastsDetails from "../pages/podcasts/single";
import PastEvents from "../pages/pastEvent";
import UpcomingEvents from "../pages/upcomingEvents";
import UpcomingEventsDetails from "../pages/upcomingEvents/single";
import ByYear from "../pages/byYear";
import ByYearDetails from "../pages/byYear/single";
import ByScale from "../pages/byScale";
import ByScaleDetails from "../pages/byScale/single";
import ByLocation from "../pages/byLocation";
import ByLocationDetails from "../pages/byLocation/single";
import Contact from "../pages/contact";
import Project from "../pages/project";
import ProjectDetail from "../pages/project/single";
import Error from "../pages/404";
import styled from "styled-components";
import Space from "../pages/space";
import ContextPage from "../pages/context";
import UrbanPage from "../pages/urban";
import MaterialPage from "../pages/material";
import RuralPage from "../pages/rural";
import Architecture from "../pages/architecture";
import Events from "../pages/events";
import ArchDetails from "../pages/architecture/single";
import SpaceDetails from "../pages/space/single";
import ContextDetails from "../pages/context/single";
import UrbanDetails from "../pages/urban/single";
import MaterialDetails from "../pages/material/single";
import RuralDetails from "../pages/rural/single";
import EventsDetails from "../pages/events/single";
import PastEventDetails from "../pages/pastEvent/single";

const MainContent = () => {
    return (
        <StyledMainContent>
            <Switch>
                <Route exact path="/" component={Home}/>
                <Route exact path="/components" component={Components}/>
                <Route exact path="/architecture" component={Architecture}/>
                <Route exact path="/architecture/:slug" component={ArchDetails}/>
                <Route exact path="/events" component={Events}/>
                <Route exact path="/events/:slug" component={EventsDetails}/>
                <Route exact path="/typology" component={Typology}/>
                <Route exact path="/typology/:slug" component={TypologyDetails}/>
                <Route exact path="/writings" component={Writings}/>
                <Route exact path="/writings/:slug" component={WritingsDetails}/>
                <Route exact path="/speeches" component={Speeches}/>
                <Route exact path="/speeches/:slug" component={SpeechesDetails}/>
                <Route exact path="/publicLectures" component={PublicLecture}/>
                <Route exact path="/publicLectures/:slug" component={PublicLectureDetails}/>
                <Route exact path="/classLecture" component={ClassLecture}/>
                <Route exact path="/classLecture/:slug" component={ClassLectureDetails}/>
                <Route exact path="/conversations" component={Conversations}/>
                <Route exact path="/conversations/:slug" component={ConversationDetails}/>
                <Route exact path="/past-event" component={PastEvents}/>
                <Route exact path="/past-event/:slug" component={PastEventDetails}/>
                <Route exact path="/upcoming-event" component={UpcomingEvents}/>
                <Route exact path="/upcoming-event/:slug" component={UpcomingEventsDetails}/>
                <Route exact path="/by-year" component={ByYear}/>
                <Route exact path="/by-year/:slug" component={ByYearDetails}/>
                <Route exact path="/by-scale" component={ByScale}/>
                <Route exact path="/by-scale/:slug" component={ByScaleDetails}/>
                <Route exact path="/by-location" component={ByLocation}/>
                <Route exact path="/by-location/:slug" component={ByLocationDetails}/>
                <Route exact path="/space" component={Space}/>
                <Route exact path="/space/:slug" component={SpaceDetails}/>
                <Route exact path="/context" component={ContextPage}/>
                <Route exact path="/context/:slug" component={ContextDetails}/>
                <Route exact path="/urban" component={UrbanPage}/>
                <Route exact path="/urban/:slug" component={UrbanDetails}/>
                <Route exact path="/material" component={MaterialPage}/>
                <Route exact path="/material/:slug" component={MaterialDetails}/>
                <Route exact path="/rural" component={RuralPage}/>
                <Route exact path="/rural/:slug" component={RuralDetails}/>
                <Route exact path="/contact" component={Contact}/>
                <Route exact path="/project" component={Project}/>
                <Route exact path="/project/:slug" component={ProjectDetail}/>
                <Route component={Error}/>
            </Switch>
        </StyledMainContent>
    );
};

const StyledMainContent = styled.main`
    margin-top: 150px;
    overflow-y: scroll; /* This hides the vertical scrollbar */
    position: relative;




    /* Tablet desktop :768px. */
    @media (min-width: 768px) and (max-width: 991px) {
        margin-top: 160px;
    }


    /* small mobile :320px. */
    @media (max-width: 767px) {
        margin-top: 160px;
    }
    

    .container {
        margin-left: unset;
    }

    /* Hiding scrollbar in different browsers */

    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;


export default MainContent;